import { Coord } from "../../../../src/types/Interface";
import TangentRatioButton from "../entities/TangentRatioButton";


export default class TangentRatioButtonManager {
  private triangle: TangentRatioButton[] = Array(3).fill(null)
    .map((_, index) => new TangentRatioButton(index));

  constructor() {
  }

  setAllVisible = (status: boolean) => this.triangle.forEach(b => {
    setTimeout(() => b.visible = status, status ? 350 : 0);
  });
  draw(coords: Coord[], sltdTPIndex: number) {
    this.triangle.forEach((button, bI) => button.draw(coords[bI], bI == sltdTPIndex));
  }
}